var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCylinderShape(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 6C7 6.79565 7.52678 7.55871 8.46447 8.12132C9.40215 8.68393 10.6739 9 12 9C13.3261 9 14.5979 8.68393 15.5355 8.12132C16.4732 7.55871 17 6.79565 17 6C17 5.20435 16.4732 4.44129 15.5355 3.87868C14.5979 3.31607 13.3261 3 12 3C10.6739 3 9.40215 3.31607 8.46447 3.87868C7.52678 4.44129 7 5.20435 7 6Z",
    fill: "#B672C0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 6V18C7 19.657 9.239 21 12 21C14.761 21 17 19.657 17 18V6",
    fill: "#B672C0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 6C7 6.79565 7.52678 7.55871 8.46447 8.12132C9.40215 8.68393 10.6739 9 12 9C13.3261 9 14.5979 8.68393 15.5355 8.12132C16.4732 7.55871 17 6.79565 17 6M7 6C7 5.20435 7.52678 4.44129 8.46447 3.87868C9.40215 3.31607 10.6739 3 12 3C13.3261 3 14.5979 3.31607 15.5355 3.87868C16.4732 4.44129 17 5.20435 17 6M7 6V18C7 19.657 9.239 21 12 21C14.761 21 17 19.657 17 18V6",
    stroke: "white",
    strokeOpacity: 0.45,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCylinderShape);
export default __webpack_public_path__ + "static/media/cylinder-shape.72997e1bdb969bc4af37715f175d59e7.svg";
export { ForwardRef as ReactComponent };